import { makeObservable, reaction } from 'mobx';

import { OneSignalService } from '../../services/oneSignal.service';
import { OptimoveService } from '../../services/optimove.service';
import { type RootStore } from '../RootStore';
import { Loadable } from '../traits/Loadable';

export class NotificationsStore extends Loadable {
  root: RootStore;

  constructor(_rootStore: RootStore) {
    super();
    makeObservable(this);
    this.root = _rootStore;

    // Login to OneSignal when user is authenticated
    reaction(
      () => this.root.authStore.authorized && !!this.root.userStore.profile?.firebaseUid,
      (isAuthenticated) => {
        const { firebaseUid } = this.root.userStore.profile ?? {};
        if (isAuthenticated && firebaseUid) {
          void OneSignalService.login(firebaseUid);
          void OptimoveService.login(firebaseUid);
        }
      },
    );

    // Show notification prompt when user completes onboarding
    reaction(
      () => this.root.onboardingStore.finishedFtue,
      (showNotificationPrompt) => {
        if (showNotificationPrompt) {
          void OneSignalService.promptPush();
        }
      },
    );
  }
}
